import React from 'react'
import Screen from '../Screen'
import Overlay from './Overlay'
import UserCard from './UserCard'
import Tracks from '../Tracks'
import { WebcamScreenProps } from './types'
import style from './WebcamScreen.module.scss'
import { VideoTrackType } from '@bt-react/components/Video'
import isEqual from 'lodash/isEqual'
import isEmpty from 'lodash/isEmpty'
import get from 'lodash/get'

/** Returns a Presenter Screen with the content type that was passed to it */
class WebcamScreen extends React.PureComponent<WebcamScreenProps> {

  state = {
    children: undefined
  }

  componentDidMount () {

    this.setChildren()
  }

  componentDidUpdate (prevProps) {

    if (!isEqual(prevProps, this.props)) {

      this.setChildren()

    }

  }

  setChildren () {

    const children = (this.props.enabledVideoTracks || []).length === 0
      ? <UserCard
        name={get(this.props, 'presenter.name', '')}
        // title={get(this.props, 'presenter.jobTitle', '')}
        photoId={get(this.props, 'presenter.photoId', '')}
        size={this.props.size ?? 'md'}
        inSidebar={this.props.inSidebar}
      />
      : <>
        <Tracks
          presenter={this.props.presenter}
          trackType={VideoTrackType.WEBCAM}
          enabledVideoTracks={this.props.enabledVideoTracks}
        />
        <Overlay
          name={get(this.props, 'presenter.name', '')}
          // title={get(this.props, 'presenter.jobTitle', '')}
          isDisabled={this.props.isOverlayDisabled}
          className={style['Screen-Overlay']}
          inSidebar={this.props.inSidebar}
        />
      </>
    this.setState({ children })

  }

  render () {

    return !isEmpty(this.props.presenter)
      ? <Screen>
        <>
        { this.state.children }
        {this.props.isBridgeInstance && this.props.isMuted && <div className={style['muted-icon']}></div>}
        </>
      </Screen>
      : null

  }

}

export default WebcamScreen
